import React, { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/components/auth/AuthContext";
import { ChangePasswordModal } from "@/components/auth/ChangePasswordModal";
import { APP_TITLE } from "@/lib/appBranding";

export function Header() {
  const { user, logout } = useAuth();
  const [showChangePassword, setShowChangePassword] = React.useState(false);

  useEffect(() => {
    document.title = APP_TITLE;
  }, []);

  return (
    <header className="header-gradient shadow-lg">
      <div className="container mx-auto p-4 flex justify-between items-center">
        <h1 className="text-2xl font-bold text-white">{APP_TITLE}</h1>
        {user && (
          <div className="flex items-center gap-4">
            <span className="text-sm text-white">
              {user.name} ({user.role})
            </span>
            <Button
              variant="default"
              onClick={() => setShowChangePassword(true)}
              className="bg-white text-gray-900 hover:bg-gray-100"
            >
              Cambiar contraseña
            </Button>
            <Button variant="default" onClick={logout} className="bg-white text-gray-900 hover:bg-gray-100">
              Cerrar Sesión
            </Button>
            <ChangePasswordModal
              open={showChangePassword}
              onClose={() => setShowChangePassword(false)}
              userEmail={user.username}
            />
          </div>
        )}
      </div>
    </header>
  );
}
